import { render, staticRenderFns } from "./getStarRatingPendingListComponent.vue?vue&type=template&id=39f0cf7e&scoped=true&"
import script from "./getStarRatingPendingListComponent.vue?vue&type=script&lang=js&"
export * from "./getStarRatingPendingListComponent.vue?vue&type=script&lang=js&"
import style0 from "./getStarRatingPendingListComponent.vue?vue&type=style&index=0&id=39f0cf7e&prod&scoped=true&lang=css&"
import style1 from "./getStarRatingPendingListComponent.vue?vue&type=style&index=1&id=39f0cf7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f0cf7e",
  null
  
)

export default component.exports